export function parseHTML(html) {
  return html
    .replace(/<!-- SC_OFF -->/g, '')
    .replace(/<!-- SC_ON -->/g, '')
    .replace(/<img src=/g, '<img loading=lazy src=')
    .replace(/<a href=/g, '<a target="_blank" rel="noopener noreferrer" href=')
    .replace(/^<div class="md">/, '')
    .replace(/<\/div>$/, '');
}
